import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import PageHeader from '@/components/Common/PageHeader'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, itemListSchema } from '@/data/structured-data'
import { medicalServices } from '@/data/services'

const ServicesIndex: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Hizmetlerimiz | Ardıç Veteriner Kliniği"
        description="Kedi ve köpekler için veterinerlik hizmetleri: acil müdahale, cerrahi, dahiliye, dermatoloji, kardiyoloji, check-up ve koruyucu hekimlik. Şanlıurfa Karaköprü."
        keywords="veteriner hizmetleri, acil veteriner, cerrahi, kedi kısırlaştırma, köpek kısırlaştırma, röntgen fiyatları, endoskopi, kardiyoloji, check-up, koruyucu hekimlik"
        canonicalUrl="/hizmetler"
        structuredData={buildGraph(
          itemListSchema({
            name: 'Veteriner Hizmetlerimiz',
            url: '/hizmetler',
            items: medicalServices.map(s => ({ name: s.title, url: `/hizmetler/${s.slug}` }))
          }),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Hizmetlerimiz', url: '/hizmetler' }
          ])
        )}
      />
      <PageHeader title="Hizmetlerimiz" subtitle="Kedi ve köpekler için kapsamlı veterinerlik hizmetleri." />
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {medicalServices.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.03 }}
                className="bg-white rounded-xl border p-0 shadow hover:shadow-lg transition overflow-hidden"
              >
                {s.image && (
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-40 object-cover"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement
                      target.src = '/klinik.webp'
                    }}
                  />
                )}
                <div className="p-6">
                <h3 className="font-bold text-lg mb-2">{s.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{s.description}</p>
                <Link to={`/hizmetler/${s.slug}`} className="text-primary-600 font-semibold">Detayları Gör</Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default ServicesIndex


